module.exports = __webpack_public_path__ + "img/kkb_moonflower.3a091c46.jpg";